<template>
  <div id="problem-behavior" class="mb-24">
    <div class="flex justify-center py-10">
      <div
        class="relative py-10 overflow-hidden border w-180 h-min bg-pure-white border-slate-400 rounded-3xl"
      >
        <div
          id="problem-behavior-header"
          class="flex items-center justify-between gap-10 pb-5 border-b bg-pure-white border-grey-200"
        >
          <div class="flex flex-col gap-1 px-10">
            <div class="flex items-center gap-2">
              <BlTextTitle3 text="Problem Behavior Codes" />
              <BlBubbleCount
                :count="(problemBehaviors && problemBehaviors.length) || 0"
              />
            </div>
            <div class="text-grey-400">
              <BlTextBody2
                text="These are the problem behavior codes for Skill-Based Treatment used in this center. Any changes made here will be applied to all existing targets."
              />
            </div>
          </div>
        </div>
        <div v-if="pageLoading" class="grid h-128 place-items-center">
          <div class="blum-loader"></div>
        </div>
        <div v-else class="">
          <div v-if="!currentUser.role.includes('admin')" class="w-full px-6">
            <div
              class="flex items-center gap-2 px-4 py-2 rounded-b bg-info-100"
            >
              <div
                class="grid flex-shrink-0 w-10 h-10 place-items-center"
                :style="{ background: '#E4F1FA', borderRadius: '0.25rem' }"
              >
                <BlIcon icon="toast-info" class="w-6 h-6" />
              </div>
              <BlTextBody1
                class="text-info"
                text="Please note that the ability to add or edit in the Repository is restricted to users with the Admin role."
              />
            </div>
          </div>
          <draggable
            handle=".handle"
            @update.prevent="onMovePosition($event)"
            class="px-10 py-6 "
            :class="
              currentUser.role.includes('admin') ? 'space-y-4' : ''
            "
          >
            <div
              v-for="problemBehavior in problemBehaviors"
              :key="problemBehavior.id"
              :id="problemBehavior.id"
              class="flex items-start gap-4"
            >
              <div
                v-if="currentUser.role.includes('admin')"
                class="flex items-center justify-center flex-shrink-0 w-2 mt-4 text-sm cursor-move handle text-grey-400"
              >
                <BlIcon icon="drag" class="flex-shrink-0 w-4" />
              </div>
              <ProblemBehaviorItem
                :problemBehavior="problemBehavior"
                @update="onUpdate"
                @delete="onRemove"
                :readOnly="!currentUser.role.includes('admin')"
                :disabledDelete="problemBehavior.is_used"
                :tooltipDelete="problemBehavior.is_used"
                tooltipPosition="left"
              />
            </div>
          </draggable>
          <div class="px-10">
            <button
              v-if="currentUser.role.includes('admin')"
              class="flex items-center gap-2 mt-5 outline-none"
              style="width: fit-content;"
              @click="onCreate"
            >
              <BlIcon icon="plus" class="w-6 h-6" />
              <span class="font-bold text-primary">Add code</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import BlBubbleCount from "../../BlBubbleCount.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextSubtitle4 from "../../BlTextSubtitle4.vue";
import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlIcon from "../../BlIcon.vue";
import { mapActions, mapGetters } from "vuex";
import ProblemBehaviorItem from "./ProblemBehaviorItem.vue";

export default {
  name: "ProblemBehavior",
  components: {
    BlTextBody2,
    BlTextTitle3,
    BlBubbleCount,
    BlTextSubtitle4,
    BlTextBody1,
    draggable,
    ProblemBehaviorItem,
    BlIcon
  },

  data() {
    return {
      pageLoading: true
    };
  },

  mounted() {
    this.fetchProblemBehaviors();
  },
  computed: {
    ...mapGetters(["currentUser", "problemBehaviors"])
  },

  methods: {
    ...mapActions([
      "getProblemBehaviors",
      "createProblemBehavior",
      "updateProblemBehavior",
      "deleteProblemBehavior",
      "moveProblemBehavior"
    ]),

    async fetchProblemBehaviors() {
      this.pageLoading = true;
      await this.getProblemBehaviors();
      this.pageLoading = false;
    },

    async onCreate() {
      const problemBehavior = {
        code: "Code",
        code_definition: "Code definition",
        color: "#DD3F30",
        description: "Behavior description"
      };
      this.createProblemBehavior({ problemBehavior });
    },
    onMovePosition(event) {
      const prompt = this.problemBehaviors[event.oldIndex];
      const newPosition = event.newIndex + 1;
      const data = {
        id: prompt.id,
        position: newPosition,
        code_definition: prompt.code_definition
      };
      this.moveProblemBehavior({ problemBehavior: data });
    },
    onUpdate(data) {
      this.updateProblemBehavior({ problemBehavior: data });
    },
    onRemove(data) {
      this.deleteProblemBehavior({ problemBehavior: data });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/sbt/ProblemBehavior.vue